import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-10 sm:py-20 px-4 bg-green-950/40 border-y border-green-700/20" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-green-950/60 p-8 sm:p-12 rounded-2xl sm:rounded-3xl shadow-xl border border-green-600/25" data-id="element-112">
          <div className="flex justify-center mb-6" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/ejXAdAwGgvkK9kHYHqxx7M/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="w-28 sm:w-36 h-auto drop-shadow-lg" data-id="element-114" />
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-white mb-6 drop-shadow-lg uppercase" data-id="element-115">
            GARANTÍA DE SATISFACCIÓN TOTAL
          </h2>

          <div className="space-y-4 text-lg text-white/80 font-medium mb-8" data-id="element-116">
            <p className="text-xl font-bold text-yellow-300 uppercase" data-id="element-117">
              Probalo durante 7 días.
            </p>
            <p data-id="element-118">
              Si sentís que el Método Venta Flash IA no era lo que esperabas,
              podés pedir la devolución dentro de ese plazo.
            </p>
            <p className="font-bold" data-id="element-119">Sin vueltas.</p>
            <p data-id="element-120">
              Solo escribinos a:
              <br data-id="element-121" />
              <a href="mailto:soporteguiadigital360@gmail.com" className="text-yellow-300 font-bold hover:underline" data-id="element-122">
                soporteguiadigital360@gmail.com
              </a>
            </p>
          </div>

          <div className="inline-block bg-yellow-300/10 text-yellow-300 font-bold px-6 py-3 rounded-full border border-yellow-300/25 uppercase" data-id="element-123">
            Tu compra está protegida.
          </div>
        </motion.div>
      </div>
    </section>;
}